<template>
    <div>
        <div class="smallContent miscContent">
            <p>
                {{ message }}
            </p>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import axios from "axios";
import { store } from "../store";
import Footer from "./Footer.vue";

export default {
    name: "Logout",
    components: {
        Footer,
    },
    data() {
        return {
            store: store,
            message: null,
        };
    },
    methods: {
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        logout() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                this.getCookie("csrftoken");
            axios.post("/api/logout").then(() => {
                localStorage.removeItem("authenticated");
                localStorage.removeItem("giftEligible");
                localStorage.removeItem("userID");
                localStorage.removeItem("lastPayed");
                myself.store.authenticated = false;
                myself.store.giftEligible = true;
                myself.store.userID = 0;
                myself.store.lastPayed = null;
                myself.store.valid = false;
                myself.message = "Logout successful";
                myself.store.privatePlayerStatus = "off";
                myself.store.privatePlayerVisible = false;
            });
        },
    },
    created() {
        axios.get("/api/login-set-cookie");
    },
    activated() {
        this.logout();
    },
};
</script>

<style scoped>
p {
    margin-bottom: 0.7rem;
    margin-top: 0;
}
</style>
